import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Modal,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core';
import useGetReasonsRefusal from '../../hooks/reasonRefusal/useGetReasonsRefusal';
import useUpdateReasonRefusal from '../../hooks/reasonRefusal/useUpdateReasonRefusal';
import { ApplicationState } from '../../store';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: 'white',
    padding: theme.spacing(4),
    borderRadius: '8px',
    outline: 'none',
    width: '400px',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.25rem',
    color: '#1c2434',
    lineHeight: '2rem',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
}));

interface IModalReasonRefusal {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reasonRefusalId: string;
}

const ModalReasonRefusal: React.FC<IModalReasonRefusal> = ({
  open,
  setOpen,
  reasonRefusalId,
}) => {
  const classes = useStyles();

  const { description: descriptionRedux, reason: reasonRedux } = useSelector(
    (state: ApplicationState) => state.reasonRefusal,
  );

  const { execute } = useUpdateReasonRefusal();
  const { execute: executeGetReasonsRefusal } = useGetReasonsRefusal();

  const [description, setDescription] = useState('');
  const [reason, setReason] = useState('');

  useEffect(() => {
    setDescription(descriptionRedux);
    setReason(reasonRedux);
  }, [descriptionRedux, reasonRedux]);

  const handleUpdateReasonRefusal = async () => {
    await Promise.all([
      execute(reasonRefusalId, reason, description, () => {
        setOpen(false);
        executeGetReasonsRefusal({ page: 1 });
      }),
    ]);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)} className={classes.modal}>
      <div className={classes.container}>
        <Typography className={classes.title}>Motivo de Recusa</Typography>
        <TextField
          id="reason"
          label="Motivo de Recusa"
          variant="outlined"
          className={classes.textField}
          fullWidth
          onChange={event => setReason(event.target.value)}
          value={reason}
        />
        <TextField
          id="description"
          label="Descrição"
          variant="outlined"
          className={classes.textField}
          fullWidth
          onChange={event => setDescription(event.target.value)}
          value={description}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1rem',
          }}
        >
          <Button
            className="primary-button"
            variant="contained"
            onClick={handleUpdateReasonRefusal}
          >
            Salvar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalReasonRefusal;
